import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ExportUsersButton from './ExportUsersButton'

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportUsersButton)



// WEBPACK FOOTER //
// ./src/views/Users/components/ExportUsersButton/index.js